'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultPortalId;
function defaultPortalId() {
  /* eslint-disable hubspot-dev/hubspot-is-special */
  if (!window.hubspot) {
    return undefined;
  }
  var _window = window,
      hubspot = _window.hubspot;

  if (hubspot.PortalIdParser && typeof hubspot.PortalIdParser.get === 'function') {
    return hubspot.PortalIdParser.get();
  }
  return hubspot.portal && hubspot.portal.id;
  /* eslint-enable hubspot-dev/hubspot-is-special */
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/lib/defaultPortalId.js
// module id = 489
// module chunks = 171